<template>

    <div>
        <MacPoolList :upperWarningBound="upperWarningBound" :upperErrorBound="upperErrorBound"/>
    </div>

</template>


<script>

    import MacPoolList from './macpools/MacPoolList.vue'
    import settingmanager from "../managers/settingmanager";

    export default {
        name: "MacPools",
        components: {
            MacPoolList
        },

        data: () => ({
            upperWarningBound: 0,
            upperErrorBound: 0
        }),
        
        created() {
            this.getUpperBoundsForPools();
        },

        methods: {
            async getUpperBoundsForPools() {
                await settingmanager.getUpperBoundsForPools(bounds => {
                    this.upperWarningBound = bounds.upperWarningBoundForPool;
                    this.upperErrorBound = bounds.upperErrorBoundForPool;
                })
            }
        }
    };


</script>

<style>
</style>




// WEBPACK FOOTER //
// src/components/MacPools.vue